import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import {
  fetchBillingEntitlements,
  quotaChipLabel,
  subscribeBillingEntitlementsInvalidate,
  type BillingEntitlements,
} from '../../lib/billing/api'

export function QuotaChip() {
  const navigate = useNavigate()
  const [entitlements, setEntitlements] = useState<BillingEntitlements | null>(null)

  useEffect(() => {
    let cancelled = false
    const load = () => {
      void fetchBillingEntitlements()
        .then((data) => {
          if (!cancelled) setEntitlements(data)
        })
        .catch(() => {
          if (!cancelled) setEntitlements(null)
        })
    }
    load()
    const unsubscribe = subscribeBillingEntitlementsInvalidate(load)
    return () => {
      cancelled = true
      unsubscribe()
    }
  }, [])

  if (!entitlements?.billing_enabled) return null

  const exhausted = entitlements.remaining <= 0
  const label = quotaChipLabel(entitlements)

  return (
    <button
      type="button"
      data-testid="quota-chip"
      onClick={() => navigate('/profile#subscription')}
      className={`rounded-full px-3 py-1 text-small font-medium transition-colors duration-fast ${
        exhausted
          ? 'bg-danger-subtle text-danger-strong border border-danger/20'
          : 'bg-surface-muted text-text-secondary border border-border-default hover:bg-surface-subtle'
      }`}
    >
      {label}
    </button>
  )
}
